import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'open-badge',
  templateUrl: './open-badge.component.html',
  styleUrls: ['./open-badge.component.scss']
})
export class OpenBadgeComponent implements OnInit {
  @Input() label!: string;
  @Input() variant?: 'default' | 'error' | 'warning' | 'success' | 'inform' | 'inactive' | 'promotion' | 'transparent' | 'decorative';
  @Input() icon?: string;
  @Input() size?: string;

  constructor() { }

  ngOnInit(): void {
  }

}
